import {
  defaultDirection,
  defaultLocale,
  defaultColor,
  localeOptions,
  themeColorStorageKey,
  themeRadiusStorageKey,
  UserRole,
} from "../constants/defaultValues";
import { hiddenToolbal } from "../helpers/TopNavManager";
import AppLocale from "../lang/index";
import { svgIcons } from "../data/svgs";
import { get } from "./Request";
import { useEffect, useState } from "react";

export const mapOrder = (array, order, key) => {
  // eslint-disable-next-line func-names
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem("direction")) {
      const localValue = localStorage.getItem("direction");
      if (localValue === "rtl" || localValue === "ltr") {
        direction = localValue;
      }
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : getDirection -> error", error);
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === "rtl",
  };
};
export const setDirection = (localValue) => {
  let direction = "ltr";
  if (localValue === "rtl" || localValue === "ltr") {
    direction = localValue;
  }
  try {
    localStorage.setItem("direction", direction);
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setDirection -> error", error);
  }
};

export const getCurrentColor = () => {
  let currentColor = defaultColor;
  try {
    if (localStorage.getItem(themeColorStorageKey)) {
      currentColor = localStorage.getItem(themeColorStorageKey);
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : getCurrentColor -> error", error);
    currentColor = defaultColor;
  }
  return currentColor;
};

export const setCurrentColor = (color) => {
  try {
    localStorage.setItem(themeColorStorageKey, color);
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentColor -> error", error);
  }
};

export const getCurrentRadius = () => {
  let currentRadius = "rounded";
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      currentRadius = localStorage.getItem(themeRadiusStorageKey);
    }
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js : getCurrentRadius -> error",
      error
    );
    currentRadius = "rounded";
  }
  return currentRadius;
};
export const setCurrentRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js : setCurrentRadius -> error",
      error
    );
  }
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language =
      localStorage.getItem("currentLanguage") &&
        localeOptions.filter(
          (x) => x.id === localStorage.getItem("currentLanguage")
        ).length > 0
        ? localStorage.getItem("currentLanguage")
        : defaultLocale;
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js : getCurrentLanguage -> error",
      error
    );
    language = defaultLocale;
  }
  return language;
};
export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem("currentLanguage", locale);
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js : setCurrentLanguage -> error",
      error
    );
  }
};

export const getNavInfo = () => {
  let nav = null;
  try {
    nav =
      localStorage.getItem("current_nav_info") != null
        ? JSON.parse(localStorage.getItem("current_nav_info"))
        : null;
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js  : getNavInfo -> error", error);
    nav = null;
  }
  return nav;
};

export const setNavInfo = (data) => {
  try {
    if (data) {
      localStorage.setItem("current_nav_info", JSON.stringify(data));
    } else {
      localStorage.removeItem("current_nav_info");
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setNavInfo -> error", error);
  }
};

export const getCurrentUserInfo = () => {
  let user = null;
  try {
    user =
      localStorage.getItem("current_user_info") != null
        ? JSON.parse(localStorage.getItem("current_user_info"))
        : null;
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js  : getCurrentUserInfo -> error",
      error
    );
    user = null;
  }
  return user;
};

export const setCurrentUserInfo = (data) => {
  try {
    if (data) {
      const d = data;
      if (typeof data.role === "string") {
        switch (data.role) {
          case "admin":
            d.role = UserRole.Admin;
            break;
          case "publisher":
            d.role = UserRole.Editor;
            break;
          default:
            d.role = UserRole.User;
            break;
        }
      } else {
        switch (data.role) {
          case 0:
            d.role = UserRole.Admin;
            break;
          case 1:
            d.role = UserRole.Editor;
            break;
          default:
            d.role = UserRole.User;
            break;
        }
      }
      localStorage.setItem("current_user_info", JSON.stringify(d));
    } else {
      localStorage.removeItem("current_user_info");
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentUser -> error", error);
  }
};
export const delCurrentUserInfo = () => {
  try {
    localStorage.removeItem("current_user_info");
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentUser -> error", error);
  }
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem("gogo_current_user") != null
        ? JSON.parse(localStorage.getItem("gogo_current_user"))
        : null;
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js  : getCurrentUser -> error", error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem("gogo_current_user", JSON.stringify(user));
    } else {
      localStorage.removeItem("gogo_current_user");
      setCurrentUserInfo(null);
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentUser -> error", error);
  }
};
export const delCurrentUser = () => {
  try {
    localStorage.removeItem("gogo_current_user");
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentUser -> error", error);
  }
};

export const getValueOfCurrentLanguage = (key) => {
  const curLang = getCurrentLanguage();
  return AppLocale[curLang].messages[key];
};

export const formatDate = (date) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = `${d.getFullYear()}`;

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day];
};

export const castToDateTime = (date) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = `${d.getFullYear()}`;

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return `${year}/${month}/${day} ${d.getHours()}:${d.getMinutes()}`;
};

export const e2p = (s) => s.replace(/[0-9]/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
export const e2a = (s) => s.replace(/[0-9]/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
export const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
export const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
export const p2a = (s) =>
  s.replace(/[۰-۹]/g, (d) => "٠١٢٣٤٥٦٧٨٩"["۰۱۲۳۴۵۶۷۸۹".indexOf(d)]);
export const a2p = (s) =>
  s.replace(/[٠-٩]/g, (d) => "۰۱۲۳۴۵۶۷۸۹"["٠١٢٣٤٥٦٧٨٩".indexOf(d)]);

export default class CommonString extends String {
  constructor(x) {
    super(x);
    this.value = x;
    this.otherInstanceProp = ":)";
  }

  setEmpty() {
    return this.value === undefined || this.value === null ? "**" : this;
  }

  isNallOrEmpty() {
    return this.value === undefined || this.value === null || this.value === "";
  }
}

export const getSiblings = (e) => {
  let siblings = [];
  if (!e.parentNode) {
    return siblings;
  }

  let sibling = e.parentNode.firstChild;

  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

export const oprClassHandler = (className, id, selectedOpr) => {

  const findSelect = document.getElementById(id);
  const siblings = document.getElementsByClassName(className);
  for (var i = 0; i < siblings.length; i++) {
    siblings[i].classList.remove("shatel", "irancell", "mci", "rightel");
  }
  findSelect.classList.add(selectedOpr);
};

export const selectHandler = (id) => {
  let element = document.getElementById(id);
  let selected = document.querySelector(".selected");
  if (selected !== null) {
    selected.classList.remove("selected");
  }
  element.classList.add("selected");
};

export const classHandler = (id, selectedOpr) => {
  const curElem = document.getElementById(id);
  if (curElem) {
    if (selectedOpr) {
      curElem.classList.add(selectedOpr);
    } else {
      curElem.classList.add("selected");
    }

    const siblings = getSiblings(curElem);
    siblings.map((item) => {
      return item.classList.remove("selected");
    });
  }
};
export const addedClass = (id, selectedOpr) => {
  const curElem = document.getElementById(id);
  if (curElem) {
    if (selectedOpr) {
      curElem.classList.add(selectedOpr);
    } else {
      curElem.classList.add("border-orange");
    }

    const siblings = getSiblings(curElem);
    siblings.map((item) => {
      return item.classList.remove("border-orange", 'border-green', 'border-blue');
    });

  }
};
export const noneClassHandler = (id) => {
  const curElem = document.getElementById(id);
  curElem.classList.remove("selected");

  const siblings = getSiblings(curElem);
  siblings.map((item) => {
    return item.classList.remove("selected");
  });
};
export const classHandlerWithChild = (id, childrens) => {
  childrens.map((item) => {
    if (item) {
      return item.classList.remove("selected");
    }
  });

  const curElem = document.getElementById(id);
  if (curElem) {
    curElem.classList.add("selected");
  }
};

export const noneClassHandlerWithChild = (childrens) => {
  childrens.map((item) => {
    return item.classList.remove("selected");
  });
};

export const pagingWithScroll = (
  onScroll = {},
  onTopScroll = {},
  onScrolling = {},
  list,
  runFunction
) => {
  const contentDIV = document.querySelector('[rel="content"]'); //.firstChild;
  function getScrollTop() {
    return contentDIV.scrollTop;
  }

  contentDIV.onload = () => {
    hiddenToolbal(false);
    onScroll = {};
    onTopScroll = {};
  };
  contentDIV.onscroll = (e) => {
    if (typeof onScrolling === "function") {
      onScrolling(e);
    }

    if (typeof onTopScroll === "function") {
      if (getScrollTop() <= 10) {
        onTopScroll();
      }
    }
    //if (contentDIV.offsetParent === null) return
    if (getScrollTop() < contentDIV.scrollHeight - contentDIV.offsetHeight - 20)
      return;
    if (typeof onScroll === "function") {
      if (list != undefined) {
        if (list != 0) {
          onScroll();
        }
      } else {
        onScroll();
      }
    }
  };
};
export const pagingWithScrollShop = (
  onScroll = {},
  onTopScroll = {},
  onScrolling = {},
  list,
  runFunction
) => {
  const contentDIV = document.querySelector('[rel="content"]'); //.firstChild;
  function getScrollTop() {
    return contentDIV.scrollTop;
  }

  contentDIV.onload = () => {
    hiddenToolbal(false);
    onScroll = {};
    onTopScroll = {};
  };
  contentDIV.onscroll = (e) => {
    if (typeof onScrolling === "function") {
      onScrolling(e);
    }

    if (typeof onTopScroll === "function") {
      if (getScrollTop() <= 10) {
        onTopScroll();
      }
    }
    //if (contentDIV.offsetParent === null) return
    if (getScrollTop() < contentDIV.scrollHeight - contentDIV.offsetHeight - 20)
      return;
    if (typeof onScroll === "function") {
      if (list != undefined) {
        if (list != 0) {
          if (runFunction) {
            onScroll();
          }
        }
      } else {
        onScroll();
      }
    }
  };
};

export const operatorList = [
  {
    isMobile: true,
    persian: getValueOfCurrentLanguage("7030.mci"),
    code: "mci",
    show: true,
    svg: svgIcons.coloredMci,
    mciSvg: svgIcons.coloredMci,
    graySvg: svgIcons.grayMci,
    chargeType: [
      {
        id: "normal",
        label: getValueOfCurrentLanguage("7030.charge.normal"),
      },
      {
        id: "young",
        label: getValueOfCurrentLanguage("7030.charge.young"),
      },
      {
        id: "ladies",
        label: getValueOfCurrentLanguage("7030.charge.ladies"),
      },
    ],
  },
  {
    isMobile: true,
    persian: getValueOfCurrentLanguage("7030.irancell"),
    code: "irancell",
    show: true,
    svg: svgIcons.coloredIrancell,
    irancellSvg: svgIcons.coloredIrancell,
    graySvg: svgIcons.grayIrancell,
    chargeType: [
      {
        id: "normal",
        label: getValueOfCurrentLanguage("7030.charge.normal"),
      },
      {
        id: "amazingirancell",
        label: getValueOfCurrentLanguage("7030.charge.amazing"),
      },
      {
        id: "postpaidbill",
        label: getValueOfCurrentLanguage("7030.charge.postpaidbill"),
      },
    ],
  },
  {
    isMobile: true,
    persian: getValueOfCurrentLanguage("7030.rightel"),
    code: "rightel",
    show: true,
    svg: svgIcons.coloredRightel,
    rightelSvg: svgIcons.coloredRightel,
    graySvg: svgIcons.grayRightel,
    chargeType: [
      {
        id: "normal",
        label: getValueOfCurrentLanguage("7030.charge.normal"),
      },
      {
        id: "amazingrightel",
        label: getValueOfCurrentLanguage("7030.charge.amazing"),
      },
    ],
  },
  {
    isMobile: true,
    persian: getValueOfCurrentLanguage("7030.shatel"),
    code: "shatel",
    show: true,
    svg: svgIcons.coloredShatel,
    shatelSvg: svgIcons.coloredShatel,
    graySvg: svgIcons.grayShatel,
    chargeType: [
      {
        id: "normal",
        label: getValueOfCurrentLanguage("7030.charge.normal"),
      },
    ],
  },
  {
    isMobile: false,
    persian: getValueOfCurrentLanguage("7030.tci"),
    code: "tci",
    show: true,
    svg: svgIcons.coloredTci,
    chargeType: [],
  },
];

export const detectOperator = (number) => {
  if (number) {
    let prefix = number.slice(2, 4);
    if (number.slice(0, 2) === "09") {
      if (
        prefix === "10" ||
        prefix === "11" ||
        prefix === "12" ||
        prefix === "13" ||
        prefix === "14" ||
        prefix === "15" ||
        prefix === "16" ||
        prefix === "17" ||
        prefix === "18" ||
        prefix === "19" ||
        prefix === "90" ||
        prefix === "91" ||
        prefix === "92" ||
        prefix === "93" ||
        prefix === "94" ||
        prefix === "95"
      ) {
        return operatorList[0];
      } else if (
        prefix === "01" ||
        prefix === "02" ||
        prefix === "03" ||
        prefix === "04" ||
        prefix === "05" ||
        prefix === "30" ||
        prefix === "33" ||
        prefix === "35" ||
        prefix === "36" ||
        prefix === "37" ||
        prefix === "38" ||
        prefix === "39" ||
        prefix === "41"
      ) {
        return operatorList[1];
      } else if (prefix === "20" || prefix === "21" || prefix === "22") {
        return operatorList[2];
      } else if (prefix === "98") {
        return operatorList[3];
      } else {
        return {
          code: "",
          svg: "",
          show: true,
          isMobile: false,
        };
      }
    } else {
      if (number.slice(0, 1) === "0") {
        return operatorList[4];
      }
      return {
        code: "",
        svg: "",
        show: true,
        isMobile: false,
      };
    }
  } else {
    return {
      code: "",
      svg: "",
      show: true,
      isMobile: false,
    };
  }
};

export const urlBase64ToUint8Array = (base64String) => {
  var padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  var base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

// Detects if device is in standalone mode
export const isInStandaloneMode = () =>
  "standalone" in window.navigator && window.navigator.standalone;
//   detect wich svg is for wich operator
export const svgDetect = (operator, colored) => {
  if (operator === "irancell") {
    if (colored) {
      return svgIcons.coloredIrancell;
    } else {
      return svgIcons.grayIrancell;
    }
  } else if (operator === "mci") {
    if (colored) {
      return svgIcons.coloredMci;
    } else {
      return svgIcons.grayMci;
    }
  } else if (operator === "rightel") {
    if (colored) {
      return svgIcons.coloredRightel;
    } else {
      return svgIcons.grayRightel;
    }
  } else if (operator === "shatel") {
    if (colored) {
      return svgIcons.coloredShatel;
    } else {
      return svgIcons.grayShatel;
    }
  }
};
export function useOutsideTrigger(ref, setTrigger) {
  // ref is refrence for your element
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setTrigger(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
  );
  return debouncedValue;
}

export function useScrollUpdate() {
  function handleScroll(e) {
    // console.log(e.target.documentElement.scrollTop)
  }
  useEffect(() => {
    document.addEventListener("scroll", handleScroll);

  }, []);
}
